var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-container"},[(_vm.ShowAnimation)?_c('canvas',{attrs:{"id":"scene","width":_vm.Width}}):_c('h3',{staticClass:"main-header"},[_vm._v(_vm._s(_vm.Title))])])}
var staticRenderFns = []

export { render, staticRenderFns }